//-- Copyright (c) 2021 TMT Insights Group, LLC

import React from 'react';
import { History, OverflowMenu } from '@/exports/columnCommonComponents';
import { Exception } from '@/redux/slices/slice_types';
import ExceptionResolve from './ExceptionResolve';
import OverflowMenuApiActionButton from '@/components/Exceptions/ActionButtons/OverflowMenuApiActionButton';
import OverflowMenuLinkActionButton from '@/components/Exceptions/ActionButtons/OverflowMenuLinkActionButton';

const ExceptionsOverflow = ({ row }: { row: Exception }) => {
  return (
    <OverflowMenu>
      <History data={row} />
      {row.status !== 'RESOLVED' && <ExceptionResolve exception={row} />}

      {!!row.actions?.length &&
        row.actions.map((action, index) =>
          action.type === 'link' ? (
            <OverflowMenuLinkActionButton key={index} action={action} references={row.references} />
          ) : (
            <OverflowMenuApiActionButton key={index} action={action} references={row.references} />
          )
        )}
    </OverflowMenu>
  );
};

export default ExceptionsOverflow;
